import TabOptionsContent from './TabOptionsContent';

export default TabOptionsContent;
